import UserInfo from './UserInfo/index.vue';
import Tongue from './Tongue/index.vue';
import Face from './Face/index.vue';
import Innate from './Innate/index.vue';
import Physique from './Physique/index.vue';
import Feature from './Feature/index.vue';
import Zangfu from './Zangfu/index.vue';
import Qixuejinye from './Qixuejinye/index.vue';
import Jingluo from './Jingluo/index.vue';
import JingluoRisk from './JingluoRisk/index.vue';
import Balance from './Balance/index.vue';
import Tendency from './Tendency/index.vue';
import Adjustment from './Adjustment/index.vue';
import PhysiqueBusiness from './PhysiqueBusiness/index.vue';
import WuzangRisk from './WuzangRisk/index.vue';
import AdjustmentFun from './AdjustmentFun/index.vue';

export {
    UserInfo,
    Tongue,
    Face,
    Innate,
    Physique,
    PhysiqueBusiness,
    WuzangRisk,
    Feature,
    Zangfu,
    Qixuejinye,
    Jingluo,
    JingluoRisk,
    Balance,
    Tendency,
    Adjustment,
    AdjustmentFun
};

export default {
    UserInfo,
    Tongue,
    Face,
    Innate,
    Physique,
    PhysiqueBusiness,
    WuzangRisk,
    Feature,
    Zangfu,
    Qixuejinye,
    Jingluo,
    JingluoRisk,
    Balance,
    Tendency,
    Adjustment,
    AdjustmentFun
};

export { canShowModule } from './helpers';
